import { useEffect, useRef } from "react";
import { useVerifiedUser } from "../hooks/useVerifiedUser";
import { Error } from "../layouts/icons";
import InfoModal from "../layouts/infoModal";
import { logActivity } from "../services/firebaseActions/activityLog";
import { getAuth } from "firebase/auth";

const AllowedUsers = ({
  children,
  permission,
  fallback = null,
  isRoute = false,
}) => {
  const { isVerified, isLoading } = useVerifiedUser(permission);

  const permissionKey = [].concat(permission).join(",");
  const hasLogged = useRef(false);

  //log if user is not verified
  useEffect(() => {
    if (isLoading) return;

    if (isVerified) {
      hasLogged.current = false; 
      return;
    }

    if (hasLogged.current) return;
    hasLogged.current = true;

    logActivity({
      category: "auth",
      event: "permission_denied",
      email: getAuth().currentUser?.email ?? null,
      message: "User attempted to access a protected route.",
      metadata: {
        permission,
        isRoute,
        url: window.location.href,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isVerified, permissionKey, isRoute]);

  if (isLoading && isRoute)
    return (
      <div className="flex min-h-screen items-center justify-center bg-white px-6">
        <div className="flex items-center gap-4">
          <div className="h-6 w-6 animate-spin rounded-full border-[3px] border-gray-200 border-t-[#008f36]" />

          <div>
            <h1 className="text-base font-semibold text-gray-900">
              Verifying your access
            </h1>

            <p className="text-sm text-gray-500">
              This will only take a few seconds.
            </p>
          </div>
        </div>
      </div>
    );

  if (isVerified) return children;

  if (isRoute && !isLoading)
    return (
      <InfoModal
        title={
          <>
            <Error />
            Unauthorized
          </>
        }
        content="Your account is not authorized to access. If you believe this is a mistake, please contact the administrator."
        buttonText="Got it!"
        navigateAction="/"
      />
    );

  return fallback;
};

export default AllowedUsers;
